import { IconType } from 'react-icons';
import { ABIcon, AnalyticsIcon, CalendarIcon, CampaignIcon, DocumentIcon, EmailIcon, FacebookIcon, FaqIcon, GoogleIcon, InstagramIcon,
  KeyIcon, LandingIcon, PinterestIcon, TextWFIcon, TikTokIcon, TitleIcon, LocationIcon, CategoryIcon} from './iconFactory';
import { PlanType, UserPlanType } from './utils';

export interface DocumentData {
  id: string;
  name: string;
  data: string;
  date: string;
}



export type ContentType = {
  name: string;
  key: string,
  Icon: IconType;
  description: string;
  iconColor?: string;
  maxLength?: number[];
};

export type InnerGroupTypeList = {
  [key: string]: ContentType[];
};

export type OuterGroupTypeList = {
  [key: string]: ContentType[] | InnerGroupTypeList
};

const group: OuterGroupTypeList = {
  Blog: [
    {name: "Blog címe", key: "Blog címe", Icon: TitleIcon, description: "Hozz létre 3 blog cím variációt a termékedhez."},
    {name: "Blogbejegyzés", key: "Blogbejegyzés", Icon: DocumentIcon, description: "Generálj 400 szavas blog bejegyzést a termékedhez.", maxLength: [400, 600, 800]}
  ],
  ProductDescription: [
    {name: "Termékleírás", key: "Termékleírás", Icon: DocumentIcon, description: "Generálj 50, 100, 150 karakteres termékleírásokat webshopod termékeihez.", maxLength: [100, 150, 200]}
  ],
  SEO: [
    {name: "Kulcsszavak", key: "Kulcsszavak", Icon: KeyIcon, description: "Generálj 5 meta kulcsszót a termékedhez."},
    {name: "Long-tail kulcsszavak", key: "Long-tail kulcsszavak", Icon: KeyIcon, description: "Készíts 5 long-tail (több szóból álló) kulcsszót."},
    {name: "Meta title", key: "Meta title", Icon: LocationIcon, description: "Készíts 60-90 karakterszámú Meta title-t.", iconColor: "text-primaryActionAltHover fill-current", maxLength: [60, 90]},
    {name: "Meta description", key: "Meta description", Icon: LocationIcon, description: "Hozz létre 130-160 karakteres Meta leírást a termékedhez.", iconColor: "text-gray50 fill-current", maxLength: [100, 160]},
    {name: "SEO content", key: "SEO kontent", Icon: LocationIcon, description: "Generálj 500 szavas bejegyzést a fő kulcsszó és long-tail kulcsszavak figyelembevételével.", iconColor: "text-tertiaryRed fill-current", maxLength: [400, 600, 800]},
    {name: "SEO tippek", key: "SEO tippek", Icon: LocationIcon, description: "Generálj 3 ötletet a webáruházad SEO optimalizálásnak elősegítésére.", iconColor: "text-tertiaryRed fill-current"},
  ],
  Email: [
    {name: "Tárgy mező", key: "Tárgy mező", Icon: EmailIcon, description: "Generálj 3 különböző tárgymezőt a  e-maileidhez."},
    {name: "Welcome e-mail flow", key: "Welcome e-mail flow", Icon: EmailIcon, description: "Készíts több e-mailből álló üdvözlő e-mail sorozatot a feliratkozóid számára."},
    {name: "Sales e-mail flow", key: "Sales e-mail flow", Icon: EmailIcon, description: "Készíts értékesítés fókuszú e-mail sorozatot a több rendelésért."},
    {name: "Post-purchase e-mail", key: "Post-purchase e-mail", Icon: EmailIcon, description: "Készíts vásárlást követő e-mail sorozatot, ami segít a kapcsolat fenntartásában."},
    {name: "Reaktiváló e-mail flow", key: "Reaktiváló e-mail flow", Icon: EmailIcon, description: "Aktiváld újra inaktív feliratkozóidat, hogy újra vásároljanak."},
    {name: "E-mail tippek", key: "E-mail tippek", Icon: EmailIcon, description: "Kérj tanácsokat az e-mail marketing csatornádhoz."}
  ],
  SocialMedia: {
    Facebook: [
      {name: "Tippek", key: "Facebook tippek", Icon: FacebookIcon, description: "Kérj tanácsokat a Facebook jelenlétedhez, amelyekről mindenképpen tudnod kell."},
      {name: "Bejegyzés", key: "Facebook bejegyzés", Icon: FacebookIcon, description: "Hozz létre bejegyzést a Facebook csatorna sajátosságait figyelembe véve."},
      {name: "Hirdetés tippek", key: "Facebook hirdetés tippek", Icon: FacebookIcon, description: "Kérj a termékkörökre szabott marketing tippeket az AI-tól a Facebook csatornádhoz."},
      {name: "Hirdetés leírása", key: "Facebook hirdetés leírása", Icon: FacebookIcon, description: "Generálj 5 db figyelemfelkeltő leírást Facebook hirdetésekhez."},
      {name: "Hirdetés címe", key: "Facebook hirdetés címe", Icon: FacebookIcon, description: "Generálj 5 db címet Facebook hirdetésekhez."},
    ],
    Instagram: [
      {name: "Tippek", key: "Instagram tippek", Icon: InstagramIcon, description: "Kérj tanácsokat az Instagram jelenlétedhez, amelyekről mindenképpen tudnod kell."},
      {name: "Bejegyzés", key: "Instagram bejegyzés", Icon: InstagramIcon, description: "Hozz létre bejegyzést az Instagram csatorna sajátosságait figyelembe véve."},
      {name: "Hirdetés leírás", key: "Instagram hirdetés leírás", Icon: InstagramIcon, description: "Generálj leírásokat az Instagram hirdetésedhez."},
      {name: "Hirdetés tippek", key: "Instagram hirdetés tippek", Icon: InstagramIcon, description: "Kérj a termékkörökre szabott marketing tippeket az AI-tól az Instagram csatornához."},
    ],
    Tiktok: [
      {name: "Tippek", key: "Tiktok tippek", Icon: TikTokIcon, description: "Kérj tanácsokat a TikTok jelenlétedhez, amelyekről mindenképpen tudnod kell."},
      {name: "Bejegyzés", key: "Tiktok bejegyzés", Icon: TikTokIcon, description: "Hozz létre bejegyzést a TikTok csatorna sajátosságait figyelembe véve."},
      {name: "Hirdetés leírás", key: "Tiktok hirdetés leírás", Icon: TikTokIcon, description: "Generálj 5 db kreatív leírást TikTok hirdetésekhez."},
      {name: "Hirdetés tippek", key: "Tiktok hirdetés tippek", Icon: TikTokIcon, description: "Kérj a termékkörökre szabott marketing tippeket az AI-tól a TikTok csatornához."},
    ],
    Pinterest: [
      {name: "Tippek", key: "Pinterest tippek", Icon: PinterestIcon, description: "Kérj tanácsokat a Pinterest jelenlétedhez, amelyekről mindenképpen tudnod kell."},
      {name: "Cím", key: "Pinterest cím", Icon: PinterestIcon, description: "Generálj 3 db címet Pinterest kampányokhoz."},
      {name: "Leírás", key: "Pinterest leírás", Icon: PinterestIcon, description: "Generálj 3 db leírást 500 karakter hosszban Pinterest kampányokhoz."},
      {name: "Hirdetés tippek", key: "Pinterest hirdetés tippek", Icon: PinterestIcon, description: "Kérj a termékkörökre szabott marketing tippeket az AI-tól az Pinterest csatornához."},
    ],
    Google: [
      {name: "Google Ads cím", key: "Google Ads cím", Icon: GoogleIcon, description: "Generálj 10 db címet Google Ads keresési kampányokhoz."},
      {name: "Google Ads leírás", key: "Google Ads leírás", Icon: GoogleIcon, description: "Generálj 4 db leírást Google Ads keresési kampányokhoz."},
      {name: "Google Ads tippek", key: "Google Ads tippek", Icon: GoogleIcon, description: "Kérj tanácsokat a Google Ads hirdetéseid futtatásához."},
      {name: "Google Cégem", key: "Google Cégem", Icon: GoogleIcon, description: "Hozz létre bejegyzést a Google Cégem csatorna sajátosságait figyelembe véve."},
    ],
  },
  WebsiteContent: [
    {name: "Főoldal tartalom", key: "Főoldal tartalom", Icon: TextWFIcon, description: "Határozd meg a webáruházad főoldalának tartalmát.", iconColor: "text-primaryActionAltHover fill-current" },
    {name: "Kategória oldal tartalom", key: "Kategória oldal tartalom", Icon: CategoryIcon, description: "Határozd meg a webáruházad kategória oldalának tartalmát."},
    {name: "Rólunk oldal tartalom", key: "Rólunk oldal tartalom", Icon: TextWFIcon, description: "Határozd meg a webáruházad bemutatkozó oldalának tartalmát.", iconColor: "text-tertiaryRed fill-current"},
    {name: "GYIK oldal tartalom", key: "GYIK oldal tartalom", Icon: FaqIcon, description: "Generálj egy kattintással 3 kérdést, amit használhatsz a GYIK oldalon."},
  ],
  Brainstorming: [
    {name: "Kampány tervezés", key: "Kampány tervezés", Icon: CampaignIcon, description: "Tervezd meg a következő kampányodat."},
    {name: "Landoló oldal", key: "Landoló oldal", Icon: LandingIcon, description: "Tervezd meg a következő landoló oldalad tartalmát."},
    {name: "Piackutatás", key: "Piackutatás", Icon: LandingIcon, description: "Kezdj bele a piackutatásba az AI segítségével."},
    {name: "Kontent naptár", key: "Kontent naptár", Icon: CalendarIcon, description: "Tervezd meg a tartalom naptáradat havi lebontásban."},
    {name: "Tippek analitikához", key: "Tippek analitikához", Icon: AnalyticsIcon, description: "Kérj ötleteket, hogy mit és miért mérj a webáruházadban a GA4-ban."},
    {name: "A/B teszt ötletek", key: "A/B teszt ötletek", Icon: ABIcon, description: "Generálj 3 ötletet A/B tesztelésre vonatkozóan, hogy még jobb legyen a konverziós arányod."},
  ]
}

export type TabType = {
  displayName: string,
  componentName: string,
  groupData: ContentType[] | InnerGroupTypeList
}
export const tabs: TabType[] = [
  { displayName: 'Blog', componentName: 'Blog', groupData: group.Blog },
  { displayName: 'Termékleírás', componentName: 'ProductDescription', groupData: group.ProductDescription },
  { displayName: 'SEO tartalmak', componentName: 'SEO', groupData: group.SEO },
  { displayName: 'E-mail tartalmak', componentName: 'Email', groupData: group.Email },
  { displayName: "Social Media és Hirdetések", componentName: "SocialMedia", groupData: group.SocialMedia },
  { displayName: 'Weboldal tartalmak', componentName: 'WebsiteContent', groupData: group.WebsiteContent },
  { displayName: "Ötletelés", componentName: "Brainstorming", groupData: group.Brainstorming },
];

export const getFirstGroupData = (group: ContentType[] | InnerGroupTypeList): ContentType => {
  if (Array.isArray(group)) {
    return group[0];
  } else {
    const firstKey = Object.keys(group)[0];
    return group[firstKey][0];
  }
};

export type selectedContentType = {
  group: string,
  content: ContentType
}

export type userType = {
  shopname: string,
  email: string,
  plan: string,
  timeout: string
}


export type PlanDataType = {
  [key: string]: PlanType;
};

export const planData: PlanDataType = {
  free: {
    id: 'free',
    planId: "",
    price: '',
    features: [
      {label: 'Blog bejegyzés generálása', key: 'Blog'},
      {label: 'Termékleírás generálása',key: 'ProductDescription'},
      {label: 'SEO tartalmak generálása',key: 'SEO'},
      {label: 'E-mail tartalmak generálása',key: 'Email'},
    ],
  },
  basic: {
    id: 'basic',
    planId: "423",
    price: '3.999',
    features: [
      {label: 'Blog bejegyzés generálása', key: 'Blog'},
      {label: 'Termékleírás generálása',key: 'ProductDescription'},
      {label: 'SEO tartalmak generálása',key: 'SEO'},
      {label: 'E-mail tartalmak generálása',key: 'Email'},
    ],
  },
  premium: {
    id: 'premium',
    planId: "425",
    price: '5.999',
    features: [
      {label: 'Blog bejegyzés generálása', key: 'Blog'},
      {label: 'Termékleírás generálása', key: 'ProductDescription'},
      {label: 'SEO tartalmak generálása', key: 'SEO'},
      {label: 'E-mail tartalmak generálása', key: 'Email'},
      {label: 'Social media tartalmak generálása, tippek', key: 'SocialMedia'},
      {label: 'Előzmények, dokumentumok', key: 'Dokumentumok'},
      {label: 'Weboldal tartalom', key: 'WebsiteContent'},
      {label: 'Ötletek, tippek', key: 'Brainstorming'},
    ],
  },
  basic_year: {
    id: 'basic_year',
    planId: "424",
    price: '39.990',
    features: [
      {label: 'Blog bejegyzés generálása', key: 'Blog'},
      {label: 'Termékleírás generálása',key: 'ProductDescription'},
      {label: 'SEO tartalmak generálása',key: 'SEO'},
      {label: 'E-mail tartalmak generálása',key: 'Email'},
    ],
  },
  premium_year: {
    id: 'premium_year',
    planId: "426",
    price: '59.990',
    features: [
      {label: 'Blog bejegyzés generálása', key: 'Blog'},
      {label: 'Termékleírás generálása', key: 'ProductDescription'},
      {label: 'SEO tartalmak generálása', key: 'SEO'},
      {label: 'E-mail tartalmak generálása', key: 'Email'},
      {label: 'Social media tartalmak generálása, tippek', key: 'SocialMedia'},
      {label: 'Előzmények, dokumentumok', key: 'Dokumentumok'},
      {label: 'Weboldal tartalom', key: 'WebsiteContent'},
      {label: 'Ötletek, tippek', key: 'Brainstorming'},
    ],
  },
};

export const isFeatureLocked = (id: string, key: string): boolean => {
  const plan = planData[id as UserPlanType];
  if (!plan) return true
  return !plan.features.some((feature) => feature.key === key);
};